import { render, staticRenderFns } from "./LifeAppliances.vue?vue&type=template&id=9bcdbcc4&scoped=true&"
import script from "./LifeAppliances.vue?vue&type=script&lang=js&"
export * from "./LifeAppliances.vue?vue&type=script&lang=js&"
import style0 from "./LifeAppliances.vue?vue&type=style&index=0&id=9bcdbcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcdbcc4",
  null
  
)

export default component.exports